export default __webpack_public_path__ + "static/media/bolts.sf.regular.ffafa0bd.ttf";